import {
    REQUEST_CALCULATION,
    RECEIVE_CALCULATION,
    UPDATE_CALCULATION,
    ERROR_CALCULATION,
    RELOAD_CALCULATION,
    UPDATE_CALCULATION_AVAILABLE_COMPANY,
    UPDATE_CALCULATION_RESULT, MODIFY_CALCULATION_RESULT, MODIFY_CALCULATION,
} from '../types'
import {initialFetchState} from '../../constants/defaultValues'
import _get from "lodash/get"
import _set from "lodash/set"
import {loadDataRefresh} from "../../constants/constants"
import _merge from "../../helpers/_merge"
import _isObject from "lodash/isObject"
import _isEmpty from "lodash/isEmpty";
import _cloneDeep from "lodash/cloneDeep";
import _isArray from "lodash/isArray";

export default (state = initialFetchState, action = {}) => {
    switch(action.type) {
        case REQUEST_CALCULATION:
            const newData = {
                ...state,
                isFetching: true,
                shouldReload: false,
                message: '',
                errors: {}
            }
            return newData
        case RECEIVE_CALCULATION:
            return {
                ...state,
                isFetching: false,
                shouldReload: false,
                data: action.merge ? _merge(state.data, action.payload, action.path) : action.payload,
                message: action.message,
            }
        case RELOAD_CALCULATION:
            return {
                ...state,
                shouldReload: true,
            }
        case UPDATE_CALCULATION:
            const data = state.data
            const d = _get(data, action.updateType, {})
            let p = action.payload
            _set(data, action.updateType, {...initialFetchState, ...d, data: p, isFetching: false, validUntil: loadDataRefresh.default + Date.now()})
            return {
                ...state,
                data,
                shouldReload: false,
                message: action.message,
            }
        case MODIFY_CALCULATION:
            const d_ = state.data
            _set(d_, action.key, action.value)
            if(action.key == "_selected"){
                const value = _isEmpty(action.value) ? [] : action.value.map(v => _get(v, "meta._c", ""))
                document.dispatchEvent(new CustomEvent('externalChange', {
                    detail: { field: "selected_company", value}
                }))
            }
            return {
                ...state,
                data: d_
            }
        case ERROR_CALCULATION:
            const newData_ = {
                ...state,
                isFetching: false,
                shouldReload: false,
                errors: action.errors,
                message: '',
            }
            if(_isObject(action.errors) && action.errors.isGET){
                newData_.data = {}
            }
            return newData_
        case UPDATE_CALCULATION_AVAILABLE_COMPANY:
            let companies = _get(state, "data.available_companies", [])
            const companyIndex = action.companyIndex
            if(companyIndex == null){
                companies = [...action.payload]
            }else{
                companies[companyIndex] = {...companies[companyIndex], ...action.payload}
            }

            const d1 = {...state.data}
            d1.available_companies = companies
            return {...state, data: d1}
        case UPDATE_CALCULATION_RESULT:
            let products = _get(state, "data.results", [])
            const productCode = action.productCode
            const companyCode = action.companyCode
            const isCombination = action.isCombination
            const merge = action.merge

            if(productCode == null){
                products = [...action.payload]
            }else{
                const productIndex= products.findIndex(p => p.code == productCode)
                if(productIndex > -1){
                    if(companyCode == null){
                        products[productIndex].companies.push(action.payload)
                    }else{
                        const companyIndex = products[productIndex].companies.findIndex(c => c.id == companyCode)
                        if(isCombination){
                            if(companyIndex == -1){
                                products[productIndex].companies.push(action.payload)
                            }else{
                                let firstSuccess = false
                                if(products[productIndex].companies[companyIndex]._uid == action.payload._uid){
                                    products[productIndex].companies[companyIndex] = {...products[productIndex].companies[companyIndex], ...action.payload}
                                    firstSuccess = action.payload.success
                                }
                                if(!firstSuccess){
                                    const resultIndex = products[productIndex].companies[companyIndex].results.findIndex(r => r._uid == action.payload._uid)
                                    const payload = action.payload.success ? {...action.payload.results[0], success: true} : action.payload
                                    if(resultIndex > -1){
                                        products[productIndex].companies[companyIndex].results[resultIndex] = {...products[productIndex].companies[companyIndex].results[resultIndex], ...payload}
                                    }else{
                                        products[productIndex].companies[companyIndex].results.push(payload)
                                    }
                                }
                                products[productIndex].companies[companyIndex].results.sort((a, b) => a.first_cost - b.first_cost)
                                const firstSorted = products[productIndex].companies[companyIndex].results[0]
                                if(firstSorted && firstSorted.success){
                                    const tmpResults = products[productIndex].companies[companyIndex].results
                                    products[productIndex].companies[companyIndex].results = tmpResults
                                    products[productIndex].companies[companyIndex].message = firstSorted.message
                                    products[productIndex].companies[companyIndex].success = firstSorted.success
                                    products[productIndex].companies[companyIndex].cost = firstSorted.cost
                                    products[productIndex].companies[companyIndex].product = firstSorted.product
                                }
                            }
                        }else{
                            if(merge){
                                if(companyIndex == -1){
                                    products[productIndex].companies.push(action.payload)
                                }else{
                                    const currentResults = products[productIndex].companies[companyIndex].results
                                    const payload = action.payload
                                    payload.results = [...payload.results, ...currentResults]
                                    products[productIndex].companies[companyIndex] = {...products[productIndex].companies[companyIndex], ...payload}
                                }
                            }else{
                                products[productIndex].companies[companyIndex] = {...products[productIndex].companies[companyIndex], ...action.payload}
                            }
                        }
                        products[productIndex].companies.sort((a, b) => a.first_cost - b.first_cost)
                    }
                }
            }

            const d2 = {...state.data}
            d2.results = products
            return {...state, data: d2}
        case MODIFY_CALCULATION_RESULT:
            let results = _get(state, "data.results", [])

            const ci = _get(results, [action.path.product_index, "companies"], []).findIndex(c => c.id == action.path.company_code)

            if(ci > -1){
                const to = [action.path.product_index, "companies", ci, "results"]
                if(action.key == "_clone"){
                    const currentResults = _get(results, to, [])
                    const v = _cloneDeep(action.value)
                    const uniqueSuffix = `_${currentResults.length}`
                    v._ptr.result_index = currentResults.length
                    v._cloned = true
                    v._selected_for_pdf_offer = false
                    v.meta._id += uniqueSuffix

                    const data_structure_compare = _get(v, "addons.data_structure_compare", [])
                    data_structure_compare.map(entry => {
                        if(entry.uuid){
                            entry.uuid += uniqueSuffix
                        }
                    })
                    v.addons.data_structure_compare = data_structure_compare
                    const data_structure = _get(v, "addons.data_structure", [])
                    data_structure.map(entry => {
                        if(typeof entry.entries != "undefined" && _isArray(entry.entries)){
                            if(entry.uuid){
                                entry.uuid += uniqueSuffix
                            }
                            entry.entries.map(eentry => {
                                if(eentry.uuid){
                                    eentry.uuid += uniqueSuffix
                                }
                                if(typeof eentry.entries != "undefined" && _isArray(eentry.entries)){
                                    eentry.entries.map(eeentry => {
                                        if(eeentry.uuid){
                                            eeentry.uuid += uniqueSuffix
                                        }
                                    })
                                }
                            })
                        }
                    })
                    v.addons.data_structure = data_structure

                    currentResults.push(v)
                    _set(results, to, currentResults)
                }else{
                    to.push(action.path.result_index)
                    const to2 = [...to, "_ptr"]

                    if(action.key == "_selected_for_detail" && action.value){
                        _set(results, [...to, "_selected_timestamp"], Date.now())
                    }

                    if(action.key){
                        to.push(action.key)
                    }
                    _set(results, to, action.value)
                    _set(results, to2, action.path)
                }
            }

            const d3 = {...state.data}
            d3.results = results
            return {...state, data: d3}
        default:
            return state
    }
}